import { useCallback } from 'react';

import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useMuteConversation } from '@web/conversations/hooks/useMuteConversation';

type Props = {
  id: number;
};

export const useMuteConversationAction = () => {
  const mutation = useMuteConversation();
  const { muteConversation } = useConversationActions();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async ({ id }: Props) => {
      await mutateAsync({ id });

      muteConversation({ id });
    },
    [mutateAsync, muteConversation]
  );

  return { action, mutation };
};
